import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-drepturi-salariale',
  templateUrl: './drepturi-salariale.component.html',
  styleUrls: ['./drepturi-salariale.component.scss']
})
export class DrepturiSalarialeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
